<template>
    <b-card border-variant="ep"
            header-bg-variant="ep"
            header-text-variant="white"
            class="mt-3 mb-3"
            :class="{'whirl ringed': !loaded}">

        <template slot="header">
            <div class="d-flex justify-content-between align-items-center">
                <div>EasyParty Evenement</div>

                <div class="badge badge-warning">
                    {{eventData ? eventData.PartijID : ''}}
                </div>
            </div>
        </template>

        <template v-if="eventData !== null">

            <div class="row spec-row">
                <div class="col-md-4">
                    <h5>Algemeen:</h5>
                </div>
                <div class="col-md-8 mb-3">
                    <div class="spec-data-row">
                        <strong>Omschrijving:</strong> {{ eventData.PartijOmschrijving }}
                    </div>
                    <div class="spec-data-row">
                        <strong>Evenementsdatum:</strong> {{ date(eventData.Datum) }}
                    </div>
                    <div class="spec-data-row">
                        <strong>Status:</strong> <b-badge variant="ep" size="sm">{{ eventData && eventData.status ? eventData.status.Status : '-' }}</b-badge>
                    </div>
                    <div class="spec-data-row">
                        <strong>Type:</strong> {{ eventData && eventData.type ? eventData.type.Omschrijving : '-' }}
                    </div>
                    <div class="spec-data-row">
                        <strong>Aard:</strong> {{ eventData && eventData.aard ? eventData.aard.Aard : '-' }}
                    </div>
                    <div class="spec-data-row">
                        <strong>Bron:</strong> {{ eventData && eventData.bron ? eventData.bron.Omschrijving : '-' }}
                    </div>
                </div>
            </div>
            <div class="row spec-row">
                <div class="col-md-4">
                    <h5>Relatie:</h5>
                </div>
                <div class="col-md-8">
                    <div class="spec-data-row">
                        <strong>Bedrijfsnaam:</strong> {{ eventData.relation.Bedrijfsnaam }}
                    </div>
                    <div class="spec-data-row">
                        <strong>Postadres:</strong> {{ eventData && eventData.postadres ? eventData.postadres.Straat + ', ' + eventData.postadres.Postcode + ' ' + eventData.postadres.Plaats : '-' }}
                    </div>
                    <div class="spec-data-row">
                        <strong>Telefoonnummer:</strong> {{ eventData && eventData.relation ? eventData.relation.Telefoon : '-' }}
                    </div>
                    <div class="spec-data-row">
                        <strong>Contactpersoon:</strong> {{ eventData.contactFullName }}
                    </div>
                </div>
            </div>

            <b-alert :show="eventData.Opmerkingen !== null" variant="secondary">
                <strong>Opmerkingen:</strong>
                <div class="pre-wrap">{{ eventData.Opmerkingen }}</div>
            </b-alert>

        </template>
        <template v-if="eventData === null">
            <p class="card-text text-muted">Geen evenement gevonden voor deze lead.</p>
        </template>
    </b-card>
</template>

<script>

    export default {
        components: {
        },
        props: {
            eventData: {
                type: Object,
                required: false
            },
            loaded: {
                type: Date,
                required: false
            },
        },
        eventData() {
            return {
                q: null,
                errors: [],
                eventData: null
            }
        },
        computed: {
        },
        watch: {
        },
        mounted() {
        },
        methods: {
            date(date) {
                let now = this.moment();
                let nowCheck = this.moment().startOf("day");
                let yest = this.moment().subtract(1, "day").startOf("day");
                let mom = this.moment(date).startOf("day");
                if(mom.isSame(now, 'day')) {
                    return 'Vandaag';
                } else if(mom.isSame(yest, 'day')) {
                    return 'Gisteren';
                }
                return mom.format('L');
            },
        }
    }

</script>

<style lang="scss">
</style>